import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import AnfrageStellen from "./sections/AnfrageStellen";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <AnfrageStellen />
      <Footer />
    </div>;
}